import { type LoadingNamespace } from '../en-US/loading';

export const loading = {
  error_description: 'Lo sentimos, hemos tenido un problema al cargar sus datos. Por favor, intente actualizar la página. Si el problema persiste, llámenos al <nobr>{{contactNumber}}</nobr> <nobr>o envíenos un correo electrónico a</nobr><br/><email />.',
  error_tile: 'Error',
  message: 'Obtenemos sus datos de un lugar seguro.',
  title: 'Cargando...',
} as const satisfies LoadingNamespace;
